// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73b31052","453":"8509665c","455":"7ed4d13c","977":"54377053"}[chunkId] + ".chunk.js";
};